import cn from 'classnames'
import { useImageLoaded } from 'ext-ui/hooks/useImageLoaded'
import React, { ComponentProps, ReactElement, ReactNode } from 'react'

import style from './Avatar.style'

type AvatarProps = {
  className?: string
  imageSrc?: string
  fallback?: string | ReactNode
  variant?: 'default' | 'outlined'
  size?: number
} & ComponentProps<'div'>

const DEFAULT_SIZE = 48

function Avatar(props: AvatarProps): ReactElement {
  const {
    className = '',
    imageSrc,
    fallback,
    variant = 'default',
    size = DEFAULT_SIZE,
    ...rest
  } = props

  const { ref, loaded, error } = useImageLoaded()

  const shouldShowImage = imageSrc && loaded && !error

  const renderFallback = () => {
    if (!fallback) {
      return <span className="fallback-text">{'?'}</span>
    }

    if (typeof fallback === 'string') {
      return (
        <span className="fallback-text">
          {fallback.charAt(0).toUpperCase()}
        </span>
      )
    }

    return fallback
  }

  return (
    <div
      className={cn('Avatar', `${variant}`, className)}
      style={
        {
          '--avatar-size': `${size}px`,
        } as React.CSSProperties
      }
      css={style}
      {...rest}
    >
      {imageSrc && (
        <img
          ref={ref}
          src={imageSrc}
          alt=""
          className={'image'}
          style={{ display: shouldShowImage ? 'block' : 'none' }}
        />
      )}
      {!shouldShowImage && <div className={'fallback'}>{renderFallback()}</div>}
    </div>
  )
}

export default Avatar
